// extracted by mini-css-extract-plugin
export default {"bridgerPaymentButton":"bSP4S"};